module.exports = __webpack_public_path__ + "static/media/about_02.23532191.png";